/* ==========================================================================
   UCC Coffee Direct: theme.js
   Vanilla JS, no framework, no build step.
   Keyboard accessible: Escape closes, focus is trapped in the mobile drawer,
   mega menu opens on hover and on focus, and closes on blur-out.
   ========================================================================== */
(function () {
  'use strict';

  var header = document.querySelector('[data-header]');
  if (!header) return;

  var overlay = document.querySelector('[data-overlay]');
  var megaWrap = header.querySelector('[data-mega]');
  var searchPanel = header.querySelector('[data-search-panel]');
  var drawer = header.querySelector('[data-drawer]');
  var burger = header.querySelector('[data-drawer-toggle]');
  /* The burger's bars are elements now and rotate into the cross off
     aria-expanded, so there is no icon markup to swap. */

  var openMegaId = null;
  var hoverTimer = null;
  var openTimer = null;
  var OPEN_DELAY = 260;   // hover intent: passing through must not open it

  /* After following a category link the pointer is often still sitting over the
     bar when the new page loads, so the browser fires mouseenter straight away
     and the mega menu opens on its own. Hover stays disarmed until the pointer
     has been somewhere other than the bar or a panel, which means the user has
     to move off and back on to open it. Keyboard focus is unaffected. */
  var hoverArmed = false;
  document.addEventListener('mousemove', function (e) {
    if (hoverArmed) return;
    var t = e.target;
    if (t && t.closest && (t.closest('[data-mega-item]') || t.closest('.mega__panel') || t.closest('[data-mega-toggle]'))) return;
    hoverArmed = true;
  }, { passive: true });

  /* ---------------------------------------------------------------- helpers */
  function setOverlay(on) {
    if (!overlay) return;
    overlay.hidden = !on;
    // Force a frame so the transition runs.
    if (on) requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    else overlay.classList.remove('is-open');
  }

  function lockScroll(on) {
    document.body.style.overflow = on ? 'hidden' : '';
  }

  /* -------------------------------------------------------------- mega menu */
  function closeMega() {
    clearTimeout(openTimer);
    if (!megaWrap) return;
    megaWrap.querySelectorAll('[data-mega-panel]').forEach(function (p) {
      p.classList.remove('is-open');
      p.hidden = true;
    });
    header.querySelectorAll('[data-mega-trigger], [data-mega-toggle]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
      var item = t.closest('[data-mega-item]');
      if (item) item.classList.remove('is-open');
    });
    openMegaId = null;
    setOverlay(false);
  }

  function openMega(id, trigger) {
    if (!megaWrap) return;
    var panel = megaWrap.querySelector('[data-mega-panel="' + id + '"]');
    if (!panel) return;
    if (openMegaId === id) return;

    closeMega();
    panel.hidden = false;
    panel.classList.add('is-open');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
      var item = trigger.closest('[data-mega-item]');
      if (item) item.classList.add('is-open');
    }
    openMegaId = id;
  }

  /* Shared so the SHOP PRODUCTS tab closes the panel as well. Without this the
     menu opened on the tab and then stayed open while the pointer moved on to
     the logo, which read as the logo triggering it. */
  function scheduleCloseMega() {
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () {
      if (header.querySelector('.mega__panel.is-open:hover')) return;
      if (header.querySelector('[data-mega-item]:hover')) return;
      if (header.querySelector('[data-mega-toggle]:hover')) return;
      closeMega();
    }, 160);
  }

  header.querySelectorAll('[data-mega-trigger]').forEach(function (trigger) {
    var id = trigger.getAttribute('data-mega-trigger');
    var item = trigger.closest('[data-mega-item]');

    // Tracked explicitly rather than read from :hover, which is not set by
    // scripted events and can go stale after a scroll.
    var isOver = false;

    function open(viaHover) {
      if (viaHover && !hoverArmed) return;
      clearTimeout(hoverTimer);
      clearTimeout(openTimer);

      if (!viaHover) return openMega(id, trigger);

      // Only open once the pointer has settled, so moving the mouse across the
      // bar no longer throws the panel over the page.
      openTimer = setTimeout(function () {
        if (!isOver) return;
        openMega(id, trigger);
      }, OPEN_DELAY);
    }

    if (item) {
      item.addEventListener('mouseenter', function () { isOver = true; open(true); });
      item.addEventListener('mouseleave', function () {
        // Leaving the bar is itself proof the pointer has moved.
        isOver = false;
        hoverArmed = true;
        clearTimeout(openTimer);
        scheduleCloseMega();
      });
    }
    trigger.addEventListener('focus', function () { open(false); });

    // Keyboard: Enter follows the link, Space opens the panel.
    trigger.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        if (openMegaId === id) closeMega();
        else open(false);
      }
    });
  });

  if (megaWrap) {
    megaWrap.addEventListener('mouseleave', scheduleCloseMega);
    megaWrap.addEventListener('mouseenter', function () { clearTimeout(hoverTimer); });
  }

  // Anything else in the header, the logo included, closes it.
  header.addEventListener('mouseleave', scheduleCloseMega);

  // Scrolling dismisses it outright: it should never sit over the page while
  // the reader is moving down it.
  window.addEventListener('scroll', function () {
    clearTimeout(openTimer);
    if (openMegaId) closeMega();
  }, { passive: true });
  var logo = header.querySelector('.header__logo');
  if (logo) logo.addEventListener('mouseenter', scheduleCloseMega);

  /* The SHOP PRODUCTS tab is a plain link to the catalogue: only the category
     bar opens the mega menu (Joshua, 5 Aug 2026). Hovering the tab closes any
     panel that happens to be open. */
  var megaToggle = header.querySelector('[data-mega-toggle]');
  if (megaToggle) {
    megaToggle.addEventListener('mouseenter', function () {
      hoverArmed = true;
      scheduleCloseMega();
    });
  }

  /* ----------------------------------------------------------- search panel */
  function closeSearch() {
    if (!searchPanel) return;
    searchPanel.classList.remove('is-open');
    header.querySelectorAll('[data-search-toggle]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
  }

  header.querySelectorAll('[data-search-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      if (!searchPanel) return;
      var isOpen = searchPanel.classList.contains('is-open');
      closeMega();
      if (isOpen) {
        closeSearch();
      } else {
        searchPanel.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        var input = searchPanel.querySelector('[data-search-input]');
        if (input) input.focus();
      }
    });
  });

  var searchClose = header.querySelector('[data-search-close]');
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  /* ---------------------------------------------------------- mobile drawer */
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    lockScroll(false);
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    lockScroll(true);
    var first = drawer.querySelector('a, input, button');
    if (first) first.focus();
  }

  if (burger) {
    burger.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) closeDrawer();
      else openDrawer();
    });
  }

  // Focus trap inside the open drawer.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !drawer || !drawer.classList.contains('is-open')) return;
    var focusables = drawer.querySelectorAll('a[href], button, input, select, textarea');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* ------------------------------------------------------------ global keys */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMega();
      closeSearch();
      if (drawer && drawer.classList.contains('is-open')) {
        closeDrawer();
        if (burger) burger.focus();
      }
    }
  });

  if (overlay) overlay.addEventListener('click', function () {
    closeMega();
    closeSearch();
    closeDrawer();
  });

  // Close the drawer when we cross back to the desktop layout.
  var mq = window.matchMedia('(min-width: 1024px)');
  var onChange = function (e) { if (e.matches) closeDrawer(); };
  if (mq.addEventListener) mq.addEventListener('change', onChange);
  else mq.addListener(onChange);
})();

/* ==========================================================================
   Homepage behaviours: carousel, footer accordions, popup.
   Each guards its own presence so the file is safe on every template.
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------- carousel */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-carousel-track]');
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (!track) return;
    // The reviews masonry is clipped, not scrollable, above the mobile breakpoint.
    var isScrollable = function () { return track.scrollWidth > track.clientWidth + 2; };

    function firstSlide() {
      return track.querySelector('.carousel__slide') || track.firstElementChild;
    }

    function step() {
      var slide = firstSlide();
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    // Line the chevrons up with the middle of the card's image, whatever sits
    // above it. The category card puts its title and copy above the image on
    // mobile, so a fixed offset would not hold.
    function placeArrows() {
      var slide = firstSlide();
      if (!slide) return;
      var media = slide.querySelector('.pcard__media, .cat-card__media, .review__media');
      if (!media) return;
      var top = media.offsetTop + media.offsetHeight / 2;
      root.style.setProperty('--arrow-top', top + 'px');
    }

    function sync() {
      if (!prev || !next) return;
      if (loopMq.matches && isScrollable()) {
        prev.disabled = false;
        next.disabled = false;
        return;
      }
      if (!isScrollable()) {
        prev.disabled = true;
        next.disabled = true;
        return;
      }
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    // Below the mobile breakpoint the sliders wrap around, so both chevrons
    // stay solid and usable. The design shows both at full strength on the
    // first card, and a dimmed white box on a white section reads as missing.
    var loopMq = window.matchMedia('(max-width: 767px)');
    function atStart() { return track.scrollLeft <= 2; }
    function atEnd() { return track.scrollLeft >= track.scrollWidth - track.clientWidth - 2; }

    if (prev) prev.addEventListener('click', function () {
      if (loopMq.matches && atStart()) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      else track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      if (loopMq.matches && atEnd()) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', function () { sync(); placeArrows(); });
    window.addEventListener('load', placeArrows);
    sync();
    placeArrows();
  });

  /* ----------------------------------------------- footer link accordions */
  var footerMq = window.matchMedia('(max-width: 767px)');
  document.querySelectorAll('[data-footer-toggle]').forEach(function (btn) {
    var panel = btn.closest('.footer__col').querySelector('[data-footer-panel]');
    if (!panel) return;

    function apply() {
      if (footerMq.matches) {
        btn.setAttribute('aria-expanded', panel.classList.contains('is-open') ? 'true' : 'false');
      } else {
        // Always open on desktop; the toggle is inert there.
        panel.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    }

    btn.addEventListener('click', function () {
      if (!footerMq.matches) return;
      panel.classList.toggle('is-open');
      apply();
    });

    if (footerMq.addEventListener) footerMq.addEventListener('change', apply);
    else footerMq.addListener(apply);
    apply();
  });

  /* ---------------------------------------------------------------- popup */
  var popup = document.querySelector('[data-popup]');
  if (popup) {
    var key = popup.getAttribute('data-popup-key');
    var days = parseInt(popup.getAttribute('data-popup-days'), 10) || 14;
    var delay = (parseInt(popup.getAttribute('data-popup-delay'), 10) || 0) * 1000;
    var lastFocus = null;

    function dismissed() {
      try {
        var until = window.localStorage.getItem(key);
        return until && Number(until) > new Date().getTime();
      } catch (e) { return false; }
    }

    function close() {
      popup.hidden = true;
      try {
        window.localStorage.setItem(key, String(new Date().getTime() + days * 864e5));
      } catch (e) {}
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }

    function open() {
      lastFocus = document.activeElement;
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
      var btn = popup.querySelector('[data-popup-close]');
      if (btn) btn.focus();
    }

    popup.querySelectorAll('[data-popup-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) close();
    });

    if (!dismissed()) window.setTimeout(open, delay);
  }

  /* ------------------------------------------------- quick add (cards) */
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var id = btn.getAttribute('data-quick-add');
      if (!id) return;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (window.uccRefreshCart) window.uccRefreshCart(cart);
          if (window.uccOpenCartDrawer && document.body.getAttribute('data-cart-type') !== 'page') {
            window.uccOpenCartDrawer();
          }
        })
        .catch(function () {})
        .then(function () { btn.disabled = false; });
    });
  });
})();

/* ==========================================================================
   Collection page: filter group toggles, mobile filter drawer.
   ========================================================================== */
(function () {
  'use strict';

  /* Filter group open/close */
  document.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  });

  /* Normalise filter option labels to Title Case when they arrive as ALL
     CAPS or with a lowercase first letter. Well-cased labels ("Ueshima",
     "Coffee Beans") are left alone so we don't churn "iPhone" into "Iphone"
     when a merchant has taken care with a tag name. Brand acronyms are then
     restored — Title Case would otherwise render UCC as "Ucc" and PG as "Pg". */
  var BRAND_ACRONYMS = /\b(Ucc|Pg)\b/g;
  document.querySelectorAll('.filter-option__label').forEach(function (el) {
    var original = el.textContent;
    if (!original) return;
    var text = original;
    var isAllUpper = text === text.toUpperCase() && text !== text.toLowerCase();
    var first = text.charAt(0);
    var firstIsLower = first !== first.toUpperCase() && first === first.toLowerCase();
    if (isAllUpper || firstIsLower) {
      text = text.toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }
    text = text.replace(BRAND_ACRONYMS, function (m) { return m.toUpperCase(); });
    if (text !== original) {
      el.textContent = text;
    }
  });

  /* An untouched price box still submits its name, which litters the URL with
     empty filter.v.price.gte= and .lte= parameters. Disabled controls are left
     out of the query string entirely, so blank ones are dropped on the way
     out. Two-way — the AJAX flow never reloads the page, so an input that was
     disabled on an earlier submit needs to come back once the user drags its
     slider off the extreme and it has a value again. */
  function pruneEmpty(form) {
    form.querySelectorAll('input[type="number"]').forEach(function (input) {
      input.disabled = input.value === '';
    });
  }

  /* All filters — availability, price, and the Brand/Type groups built on top
     of S&D's "Product tag" filter — submit as normal query params. We fetch
     the rendered section via the Section Rendering API and swap
     #collection-results in place. The browser URL carries availability and
     price so refresh preserves them, but filter.p.tag params are stripped
     via replaceState so tag names never linger there. On refresh, tag state
     is lost — the trade-off for a clean URL. */
  var RESULTS_ID = 'collection-results';
  var TAG_PARAM = 'filter.p.tag';

  function collectFormState(form) {
    var params = new URLSearchParams();
    form.querySelectorAll('input[name], select[name]').forEach(function (el) {
      if (el.disabled) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (el.value === '') return;
      params.append(el.name, el.value);
    });
    return { params: params };
  }

  function submitFilters(form, extraParams) {
    pruneEmpty(form);

    var base = form.getAttribute('data-collection-url');
    var sectionId = form.getAttribute('data-section-id');
    var target = document.getElementById(RESULTS_ID);

    // Any of these missing means we can't do the AJAX path — fall back to
    // a plain navigation. This should not happen on a normally-wired collection.
    if (!base || !sectionId || !target || !window.fetch) {
      var qs = collectFormState(form).params.toString();
      window.location.assign(base + (qs ? '?' + qs : ''));
      return;
    }

    var state = collectFormState(form);
    if (extraParams) {
      Object.keys(extraParams).forEach(function (k) { state.params.set(k, extraParams[k]); });
    }
    var fetchParams = new URLSearchParams(state.params);
    fetchParams.set('section_id', sectionId);
    var fetchUrl = base + '?' + fetchParams.toString();

    target.setAttribute('aria-busy', 'true');

    fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(RESULTS_ID);
        // The Section Rendering API returns just the section, so the results
        // container might be at the top level or wrapped depending on markup.
        if (fresh) {
          target.innerHTML = fresh.innerHTML;
        } else {
          target.innerHTML = html;
        }

        // Update the browser URL: keep availability/price, strip filter.p.tag
        // so tag names don't appear in the URL. Base off data-collection-url
        // rather than window.location.pathname so a URL that arrived with tags
        // gets tidied on the first interaction.
        var browserParams = new URLSearchParams(state.params);
        browserParams.delete(TAG_PARAM);
        var browserQs = browserParams.toString();
        var browserUrl = base + (browserQs ? '?' + browserQs : '');
        window.history.replaceState({}, '', browserUrl);

        // If Apply was tapped in the mobile drawer, close it — the full
        // navigation used to do that for free.
        if (form.id === 'filters-mobile') {
          var closer = document.querySelector('[data-filter-drawer] [data-filter-close]');
          if (closer) closer.click();
        }
      })
      .catch(function () {
        // Give the user something useful if the fetch fails.
        window.location.assign(fetchUrl.replace(/([?&])section_id=[^&]*&?/, '$1').replace(/[?&]$/, ''));
      })
      .then(function () {
        target.removeAttribute('aria-busy');
      });
  }

  document.querySelectorAll('form.filters').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submitFilters(form);
    });
  });

  /* Desktop rail submits on change; the mobile drawer waits for Apply.
     Number inputs' change fires on blur or Enter (not per keystroke — that's
     the input event, which drives the slider position via fromNumber but
     doesn't submit), so typing a price and tabbing out triggers a fetch
     alongside the slider release and the checkbox toggles. */
  var deskForm = document.getElementById('filters-desktop');
  if (deskForm) {
    deskForm.addEventListener('change', function () {
      submitFilters(deskForm);
    });
  }

  /* Pagination via AJAX. The results container persists across swaps (only
     its innerHTML is replaced), so a single delegated listener stays live.
     Pick the form that matches the current viewport — the desktop rail is
     display:none below 768px but still in the DOM, and mobile filter state
     lives on the drawer form. */
  var mediaDesk = window.matchMedia('(min-width: 768px)');
  function activeFilterForm() {
    if (mediaDesk.matches && deskForm) return deskForm;
    return document.getElementById('filters-mobile') || deskForm;
  }

  var results = document.getElementById(RESULTS_ID);
  if (results) {
    results.addEventListener('click', function (e) {
      var link = e.target.closest('.pagination a');
      if (!link || !link.href) return;
      var form = activeFilterForm();
      if (!form) return;
      e.preventDefault();
      var page = new URL(link.href, window.location.origin).searchParams.get('page') || '1';
      submitFilters(form, { page: page });
      // Take the user back to the top of the grid so page 2 starts at product 1.
      results.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
  }

  /* Mobile filter drawer */
  var drawer = document.querySelector('[data-filter-drawer]');
  if (!drawer) return;
  var opener = document.querySelector('[data-filter-open]');
  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    if (opener) opener.setAttribute('aria-expanded', 'true');
    var first = drawer.querySelector('button, input');
    if (first) first.focus();
  }

  function close() {
    drawer.hidden = true;
    document.body.style.overflow = '';
    if (opener) opener.setAttribute('aria-expanded', 'false');
    if (lastFocus) lastFocus.focus();
  }

  if (opener) opener.addEventListener('click', open);
  drawer.querySelectorAll('[data-filter-close]').forEach(function (b) {
    b.addEventListener('click', close);
  });
  drawer.addEventListener('click', function (e) {
    if (e.target === drawer) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) close();
  });
})();

/* ==========================================================================
   Dual-handle price filter. Two overlaid range inputs drive the fill bar and
   stay in sync with the numeric fields either way round.
   ========================================================================== */
(function () {
  'use strict';

  document.querySelectorAll('[data-price-filter]').forEach(function (root) {
    var top = parseFloat(root.getAttribute('data-top')) || 100;
    var rMin = root.querySelector('[data-price-range="min"]');
    var rMax = root.querySelector('[data-price-range="max"]');
    var nMin = root.querySelector('[data-price-input="min"]');
    var nMax = root.querySelector('[data-price-input="max"]');
    var fill = root.querySelector('[data-price-fill]');
    if (!rMin || !rMax) return;

    function pct(v) { return (v / top) * 100; }

    function paint() {
      var lo = Math.min(Number(rMin.value), Number(rMax.value));
      var hi = Math.max(Number(rMin.value), Number(rMax.value));
      fill.style.left = pct(lo) + '%';
      fill.style.right = (100 - pct(hi)) + '%';
    }

    // Dragging one handle must not push past the other.
    function clamp(which) {
      var lo = Number(rMin.value);
      var hi = Number(rMax.value);
      if (which === 'min' && lo > hi) rMin.value = hi;
      if (which === 'max' && hi < lo) rMax.value = lo;
    }

    function fromRange(which) {
      clamp(which);
      paint();
      // Leave the field blank at the extremes so Shopify treats it as unset.
      if (nMin) nMin.value = Number(rMin.value) === 0 ? '' : rMin.value;
      if (nMax) nMax.value = Number(rMax.value) === top ? '' : rMax.value;
    }

    function fromNumber() {
      var lo = nMin && nMin.value !== '' ? parseFloat(nMin.value) : 0;
      var hi = nMax && nMax.value !== '' ? parseFloat(nMax.value) : top;
      if (isNaN(lo)) lo = 0;
      if (isNaN(hi)) hi = top;
      lo = Math.max(0, Math.min(lo, top));
      hi = Math.max(0, Math.min(hi, top));
      if (lo > hi) { var t = lo; lo = hi; hi = t; }
      rMin.value = lo;
      rMax.value = hi;
      paint();
    }

    rMin.addEventListener('input', function () { fromRange('min'); });
    rMax.addEventListener('input', function () { fromRange('max'); });
    if (nMin) nMin.addEventListener('input', fromNumber);
    if (nMax) nMax.addEventListener('input', fromNumber);

    // The range's native `change` event bubbles to the form on slider release,
    // and the collection IIFE's on-change delegation picks it up and routes
    // through the AJAX submitFilters helper — no explicit form.submit() here.

    fromNumber();
  });
})();

/* ==========================================================================
   Product page: quantity stepper, add to cart.

   The callback modal used to live here. It is now self-contained in
   snippets/callback-form.liquid, which also renders as a product block, so its
   JS has to ship with the markup rather than from this file.
   ========================================================================== */
(function () {
  'use strict';

  /* Quantity stepper */
  document.querySelectorAll('[data-qty]').forEach(function (root) {
    var input = root.querySelector('[data-qty-input]');
    if (!input) return;
    function bump(by) {
      var v = parseInt(input.value, 10);
      if (isNaN(v)) v = 1;
      input.value = Math.max(1, v + by);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var down = root.querySelector('[data-qty-down]');
    var up = root.querySelector('[data-qty-up]');
    if (down) down.addEventListener('click', function () { bump(-1); });
    if (up) up.addEventListener('click', function () { bump(1); });
    input.addEventListener('blur', function () {
      if (!input.value || parseInt(input.value, 10) < 1) input.value = 1;
    });
  });

  /* Add to cart: keep the user on the page and confirm in place */
  document.querySelectorAll('[data-add-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;             // let it post normally
      e.preventDefault();
      var btn = form.querySelector('[data-atc], button[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

      var idField = form.querySelector('[name="id"]');
      var qtyField = form.querySelector('[name="quantity"]');
      var payload = {
        items: [{
          id: Number(idField && idField.value),
          quantity: parseInt(qtyField ? qtyField.value : 1, 10) || 1
        }]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (window.uccRefreshCart) window.uccRefreshCart(cart);
          if (window.uccOpenCartDrawer && document.body.getAttribute('data-cart-type') !== 'page') {
            window.uccOpenCartDrawer();
          }
          if (btn) {
            btn.classList.add('is-added');
            btn.textContent = 'Added to cart';
            setTimeout(function () {
              btn.classList.remove('is-added');
              btn.textContent = label;
              btn.disabled = false;
            }, 2200);
          }
        })
        .catch(function () {
          if (btn) { btn.textContent = label; btn.disabled = false; }
        });
    });
  });
})();

/* ==========================================================================
   Reveal on scroll.

   Elements are tagged from JS rather than in the markup, so every template
   picks this up without touching its Liquid, and the page stays fully visible
   if JS never runs. Children of a group stagger.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce.matches || !('IntersectionObserver' in window)) return;

  // Single elements that rise on their own.
  var SINGLES = [
    '.hero__heading', '.hero__text', '.hero__cta',
    '.section__heading', '.section__intro',
    '.offer__panel', '.offer__media',
    '.acc-layout__intro', '.reviews__summary',
    '.collection__title', '.collection__bar', '.collection__rail',
    '.product__info', '.faq__heading',
    '.pagination',
    '.footer__bar', '.article__lead', '.article__rte', '.article__back',
    '.cart__footer', '.login__card', '.contact__form-col', '.page__intro'
  ];

  // Groups whose direct children stagger in sequence.
  var GROUPS = [
    // The hero's heading, paragraph and button come in one after the other,
    // which is the first thing anyone sees on the homepage.
    '.hero__content',
    '.usp__list', '.cat-grid', '.pgrid', '.acc-layout__list',
    '.reviews__grid', '.footer__cols', '.faq__list', '.carousel__track',
    '.tile-grid', '.blog__filters', '.faq__quicklinks', '.contact__aside',
    '.cart__table tbody', '.login__side'
  ];

  // Media that rises with a slight settle.
  var MEDIA = ['.hero__media', '.collection__banner', '.product__media'];

  var STAGGER = 70;   // ms between siblings
  var MAX_DELAY = 350;

  function tag(el, cls, delay) {
    if (!el || el.classList.contains('reveal')) return;
    el.classList.add('reveal');
    if (cls) el.classList.add(cls);
    if (delay) el.style.setProperty('--reveal-delay', delay + 'ms');
  }

  SINGLES.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) { tag(el); });
  });

  MEDIA.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) { tag(el, 'reveal--media'); });
  });

  GROUPS.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        // The reviews masonry nests cards inside column wrappers.
        var targets = child.classList && child.classList.contains('reviews__col')
          ? Array.prototype.slice.call(child.children)
          : [child];
        targets.forEach(function (t, j) {
          tag(t, null, Math.min((i + j) * STAGGER, MAX_DELAY));
        });
      });
    });
  });

  var nodes = document.querySelectorAll('.reveal');
  if (!nodes.length) return;

  document.documentElement.classList.add('reveal-ready');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  nodes.forEach(function (n) { io.observe(n); });

  // Anything already in view when the page loads comes in immediately.
  requestAnimationFrame(function () {
    nodes.forEach(function (n) {
      var r = n.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        n.classList.add('is-visible');
        io.unobserve(n);
      }
    });
  });
})();

/* ==========================================================================
   Product gallery: arrows, thumbnails and swipe stay in sync.
   ========================================================================== */
(function () {
  'use strict';

  document.querySelectorAll('[data-gallery]').forEach(function (root) {
    var track = root.querySelector('[data-gallery-track]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-slide]'));
    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    if (!track || slides.length < 2) return;

    var index = 0;

    function mark(i) {
      index = Math.max(0, Math.min(i, slides.length - 1));
      thumbs.forEach(function (t, n) {
        var on = n === index;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    function go(i) {
      // Wrap around so the arrows never dead-end.
      if (i < 0) i = slides.length - 1;
      if (i > slides.length - 1) i = 0;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      mark(i);
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        go(parseInt(t.getAttribute('data-gallery-thumb'), 10) || 0);
      });
    });

    // Swiping updates the active thumbnail.
    var settle;
    track.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(function () {
        var w = track.clientWidth || 1;
        mark(Math.round(track.scrollLeft / w));
      }, 90);
    }, { passive: true });

    mark(0);
  });
})();

/* ==========================================================================
   Cart drawer: opens from the header cart, and after an add to cart when the
   theme setting asks for it. Falls back to the cart page if the drawer is
   absent, so the header link always works.
   ========================================================================== */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  var lastFocus = null;

  var panel = drawer.querySelector('.cart-drawer__panel');

  /* Sit directly beneath the header wherever it happens to be. Once the header
     has scrolled away the drawer hugs the top of the viewport instead of
     floating at a fixed offset down the page. */
  function position() {
    if (!panel) return;
    var header = document.querySelector('[data-header]');
    var top = 0;
    if (header) {
      var r = header.getBoundingClientRect();
      top = Math.max(0, Math.min(r.bottom, window.innerHeight));
    }
    panel.style.top = top + 'px';
    panel.style.maxHeight = 'calc(100vh - ' + top + 'px)';
  }

  function lock() { document.body.style.overflow = 'hidden'; }

  /* An eased scroll of our own rather than native smooth behaviour: the panel
     can then be positioned once, after the page has come to rest, instead of
     being nudged every frame while the header is still moving. */
  function scrollToTop(done) {
    var start = window.scrollY;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var finished = false;

    function finish() {
      if (finished) return;
      finished = true;
      window.scrollTo(0, 0);
      done();
    }

    if (start <= 0 || reduce) return finish();

    var t0 = null;
    var duration = Math.min(700, 260 + start * 0.22);

    function frame(ts) {
      if (finished) return;
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / duration);
      var eased = 1 - Math.pow(1 - p, 3);        // ease-out cubic
      window.scrollTo(0, Math.round(start * (1 - eased)));
      if (p < 1) requestAnimationFrame(frame);
      else finish();
    }
    requestAnimationFrame(frame);

    // Animation frames are throttled in background tabs, so guarantee the
    // drawer still opens if they never arrive.
    setTimeout(finish, duration + 220);
  }

  function open() {
    if (!drawer.hidden) return;
    lastFocus = document.activeElement;

    // The lock has to be off for the scroll to run at all.
    document.body.style.overflow = '';

    scrollToTop(function () {
      position();
      drawer.hidden = false;
      // One frame later so the entrance transition has a state to move from.
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      lock();
      var f = drawer.querySelector('button, a');
      if (f) f.focus({ preventScroll: true });
    });
  }

  window.addEventListener('resize', function () { if (!drawer.hidden) position(); });

  function close() {
    drawer.classList.remove('is-open');
    drawer.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  window.uccOpenCartDrawer = open;

  // The header cart opens the drawer rather than navigating.
  document.querySelectorAll('[data-cart-toggle]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
  });

  drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (b) {
    b.addEventListener('click', close);
  });
  drawer.addEventListener('click', function (e) {
    if (e.target === drawer) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) close();
  });

  // Keep focus inside while open.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || drawer.hidden) return;
    var f = drawer.querySelectorAll('a[href], button, input, select, textarea');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();

/* ==========================================================================
   Cart page: quantity changes and remove update the cart without a reload.
   ========================================================================== */
(function () {
  'use strict';

  var form = document.querySelector('[data-cart-form]');
  if (!form || !window.fetch) return;

  function change(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { form.submit(); });
  }

  form.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      change(input.getAttribute('data-cart-qty'), parseInt(input.value, 10) || 0);
    });
  });

  form.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      change(btn.getAttribute('data-cart-remove'), 0);
    });
  });
})();

/* ==========================================================================
   Keep every cart readout in step: header count and total, drawer lines and
   drawer total. Called after any add so nothing needs a page reload.
   ========================================================================== */
(function () {
  'use strict';

  function money(cents) {
    return '£' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function lineMarkup(item, isLast, totalHtml) {
    var img = item.image
      ? '<img src="' + item.image + '" alt="" loading="lazy">'
      : '';
    return '' +
      '<div class="cart-drawer__item">' +
        '<a href="' + item.url + '" class="cart-drawer__media' + (item.image ? '' : ' cart-drawer__media--empty') + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
        '<div class="cart-drawer__detail">' +
          '<p class="cart-drawer__meta">' + (item.product ? item.product.vendor : '') +
            (item.sku ? ' &nbsp;|&nbsp; SKU:' + item.sku : '') + '</p>' +
          '<p class="cart-drawer__price">' + money(item.final_line_price) + '</p>' +
          '<button type="button" class="cart-drawer__remove" data-drawer-remove="' + item.key + '">' +
            'Remove item</button>' +
          (isLast ? totalHtml : '') +
        '</div>' +
      '</div>';
  }

  window.uccRefreshCart = function (cart) {
    if (!cart) return;

    document.querySelectorAll('[data-cart-count]').forEach(function (n) {
      n.textContent = cart.item_count;
      // The mobile badge is only drawn when there is something in the cart.
      if (n.classList.contains('cart-badge')) n.hidden = cart.item_count === 0;
    });
    document.querySelectorAll('[data-cart-total]').forEach(function (n) {
      n.textContent = money(cart.total_price);
    });

    // Cross-sell follows the cart: hidden while it is empty.
    var pick = document.querySelector('.cart-drawer__pick');
    if (pick) pick.hidden = !cart.item_count;

    var wrap = document.querySelector('[data-cart-drawer-items]');
    if (!wrap) return;

    if (!cart.items || !cart.items.length) {
      wrap.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      return;
    }
    var totalHtml = '<p class="cart-drawer__total">Total: <span data-cart-total>' +
      money(cart.total_price) + '</span></p>';
    wrap.innerHTML = cart.items.map(function (item, i) {
      return lineMarkup(item, i === cart.items.length - 1, totalHtml);
    }).join('');
    wrap.hidden = false;
  };

  // The mobile badge needs to exist even when the cart starts empty.
  document.querySelectorAll('.header__cart--mobile').forEach(function (el) {
    if (el.querySelector('.cart-badge')) return;
    var b = document.createElement('span');
    b.className = 'cart-badge';
    b.setAttribute('data-cart-count', '');
    b.textContent = '0';
    b.hidden = true;
    el.appendChild(b);
  });
})();

/* Removing a line from the cart drawer. Delegated, because the drawer's
   contents are rebuilt whenever the cart changes. */
(function () {
  'use strict';
  if (!window.fetch) return;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-drawer-remove]') : null;
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: btn.getAttribute('data-drawer-remove'), quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (window.uccRefreshCart) window.uccRefreshCart(cart); })
      .catch(function () { btn.disabled = false; });
  });
})();

/* ==========================================================================
   Blog category filter. Articles and page tiles share one grid, so filtering
   happens client side rather than through Shopify's tag routes.
   ========================================================================== */
(function () {
  'use strict';

  var grid = document.querySelector('[data-blog-grid]');
  if (!grid) return;
  var pills = Array.prototype.slice.call(document.querySelectorAll('[data-blog-filter]'));
  var empty = document.querySelector('[data-blog-empty]');
  if (!pills.length) return;

  function apply(cat) {
    var shown = 0;
    Array.prototype.forEach.call(grid.children, function (item) {
      var match = cat === 'all' || item.getAttribute('data-category') === cat;
      item.hidden = !match;
      if (match) shown++;
    });
    if (empty) empty.hidden = shown > 0;
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      pills.forEach(function (p) {
        var on = p === pill;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      apply(pill.getAttribute('data-blog-filter'));
    });
  });
})();

/* ==========================================================================
   Quick view. Delegates on [data-quickview] chips in product cards, fetches
   the product from /products/handle.js, and populates the shared modal from
   snippets/quick-view-modal.liquid. Pack size isn't in the .js payload, so
   the chip carries it as a data attribute for the modal to pick up.
   ========================================================================== */
(function () {
  'use strict';

  var modal = document.querySelector('[data-quickview-modal]');
  if (!modal) return;

  var slidesEl = modal.querySelector('[data-qv-slides]');
  var titleEl = modal.querySelector('[data-qv-title]');
  var metaEl = modal.querySelector('[data-qv-meta]');
  var descEl = modal.querySelector('[data-qv-desc]');
  var priceEl = modal.querySelector('[data-qv-price]');
  var variantEl = modal.querySelector('[data-qv-variant-id]');
  var addBtn = modal.querySelector('[data-qv-add]');
  var prevBtn = modal.querySelector('[data-qv-prev]');
  var nextBtn = modal.querySelector('[data-qv-next]');
  var index = 0;
  var slideCount = 0;
  var lastFocus = null;

  function money(cents) {
    var whole = (cents / 100).toFixed(2);
    return '£' + whole;
  }

  function stripAndTruncate(html, limit) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    var text = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
    if (text.length <= limit) return text;
    return text.slice(0, limit).replace(/\s+\S*$/, '') + '…';
  }

  function sizedUrl(url, width) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', width);
      return u.toString();
    } catch (e) { return url; }
  }

  function goto(i) {
    if (slideCount === 0) return;
    index = ((i % slideCount) + slideCount) % slideCount;
    slidesEl.style.transform = 'translateX(' + (-index * 100) + '%)';
  }

  function open() {
    lastFocus = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closer = modal.querySelector('[data-quickview-close]');
    if (closer) closer.focus();
  }

  function close() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function populate(product, packSize) {
    titleEl.textContent = product.title || '';

    var meta = [];
    if (packSize) meta.push(packSize);
    if (product.vendor) meta.push(product.vendor);
    metaEl.textContent = meta.join(' | ');

    descEl.textContent = stripAndTruncate(product.description, 160);
    priceEl.textContent = money(product.price);

    var firstVariant = product.variants && product.variants[0];
    if (firstVariant) {
      variantEl.value = firstVariant.id;
      if (addBtn) {
        addBtn.disabled = !firstVariant.available;
        addBtn.textContent = firstVariant.available ? 'Add to cart' : 'Sold out';
      }
    }

    // product.images is Shopify's flat list of every product image URL and
    // is populated across accounts and API versions. Use it as the primary
    // source. product.media is a secondary fallback for the rare case where
    // images is empty but media has image entries — skip anything that
    // declares a non-image media_type (video, model, external_video).
    slidesEl.innerHTML = '';
    var srcs = [];
    if (product.images && product.images.length) {
      srcs = product.images.slice();
    } else if (product.media && product.media.length) {
      product.media.forEach(function (m) {
        if (!m) return;
        if (m.media_type && m.media_type !== 'image') return;
        var s = (m.preview_image && m.preview_image.src) || m.src;
        if (s) srcs.push(s);
      });
    }
    if (!srcs.length && product.featured_image) {
      srcs = [product.featured_image];
    }
    slideCount = srcs.length;

    if (slideCount === 0) {
      var placeholder = document.createElement('li');
      placeholder.className = 'qv__slide--empty';
      slidesEl.appendChild(placeholder);
    } else {
      srcs.forEach(function (src) {
        var li = document.createElement('li');
        var img = document.createElement('img');
        img.src = sizedUrl(src, 600);
        img.alt = product.title || '';
        img.loading = 'lazy';
        li.appendChild(img);
        slidesEl.appendChild(li);
      });
    }
    var hasCarousel = slideCount > 1;
    if (prevBtn) prevBtn.hidden = !hasCarousel;
    if (nextBtn) nextBtn.hidden = !hasCarousel;
    goto(0);
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-quickview]');
    if (chip) {
      e.preventDefault();
      var handle = chip.getAttribute('data-product-handle');
      if (!handle) return;
      var packSize = chip.getAttribute('data-pack-size') || '';

      // Reset before fetch so the modal never briefly shows a stale product.
      titleEl.textContent = '';
      metaEl.textContent = '';
      descEl.textContent = '';
      priceEl.textContent = '';
      slidesEl.innerHTML = '';
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Loading…'; }
      open();

      fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (p) { populate(p, packSize); })
        .catch(function () {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
          descEl.textContent = 'Sorry, we could not load this product.';
        });
      return;
    }

    if (e.target.closest('[data-quickview-close]')) {
      close();
    }
  });

  if (prevBtn) prevBtn.addEventListener('click', function () { goto(index - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goto(index + 1); });

  document.addEventListener('keydown', function (e) {
    if (modal.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') goto(index - 1);
    else if (e.key === 'ArrowRight') goto(index + 1);
  });

  // Close the modal once the shared add-to-cart handler confirms the add —
  // it flips is-added on the button, so watch for that class.
  if (addBtn) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.attributeName === 'class' && addBtn.classList.contains('is-added')) {
          close();
        }
      });
    }).observe(addBtn, { attributes: true });
  }
})();

/* ==========================================================================
   Hero carousel. Autoplays every N ms from data-hero-autoplay; pauses on
   hover, focus, tab hidden and prefers-reduced-motion. Prev/next arrows,
   dot pagination and keyboard arrow keys all reset the autoplay timer so
   user interaction gets full time before the next auto-advance.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var track = hero.querySelector('[data-hero-track]');
    if (!track) return;
    var slides = track.children;
    var count = slides.length;
    if (count <= 1) return;

    var prevBtn = hero.querySelector('[data-hero-prev]');
    var nextBtn = hero.querySelector('[data-hero-next]');
    var dots = hero.querySelectorAll('[data-hero-dot]');
    var interval = parseInt(hero.getAttribute('data-hero-autoplay'), 10) || 0;

    var index = 0;
    var timer = null;
    var paused = false;

    function goto(i) {
      index = ((i % count) + count) % count;
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      dots.forEach(function (d, di) {
        var on = di === index;
        d.classList.toggle('is-current', on);
        if (on) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }

    function start() {
      stop();
      if (!interval) return;
      if (paused) return;
      if (reduceMotion.matches) return;
      timer = setInterval(function () { goto(index + 1); }, interval);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function bump() { start(); }  // reset timer after manual nav

    if (prevBtn) prevBtn.addEventListener('click', function () { goto(index - 1); bump(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goto(index + 1); bump(); });
    dots.forEach(function (d, di) {
      d.addEventListener('click', function () { goto(di); bump(); });
    });

    hero.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { goto(index - 1); bump(); }
      else if (e.key === 'ArrowRight') { goto(index + 1); bump(); }
    });

    // Pause on hover / focus, resume when the user leaves. Touch devices
    // won't fire mouseenter so autoplay just continues there.
    hero.addEventListener('mouseenter', function () { paused = true; stop(); });
    hero.addEventListener('mouseleave', function () { paused = false; start(); });
    hero.addEventListener('focusin', function () { paused = true; stop(); });
    hero.addEventListener('focusout', function () { paused = false; start(); });

    // Touch swipe. A pure tap (no horizontal motion) is ignored so taps on
    // links/CTAs inside a slide don't pause autoplay or advance. Swipe mode
    // only engages once touchmove reports > 10px horizontal (and horizontal
    // exceeds vertical, so vertical page scroll isn't intercepted). Once
    // engaged, a release with |dx| > 40 commits the swipe.
    var startX = 0, startY = 0, isSwiping = false;
    hero.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { isSwiping = false; return; }
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isSwiping = false;
    }, { passive: true });
    hero.addEventListener('touchmove', function (e) {
      if (isSwiping || e.touches.length !== 1) return;
      var t = e.touches[0];
      var dx = Math.abs(t.clientX - startX);
      var dy = Math.abs(t.clientY - startY);
      if (dx > 10 && dx > dy) {
        isSwiping = true;
        paused = true;
        stop();
      }
    }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (!isSwiping) return;
      isSwiping = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - startX;
      if (Math.abs(dx) > 40) {
        if (dx < 0) goto(index + 1); else goto(index - 1);
      }
      paused = false;
      start();
    });
    hero.addEventListener('touchcancel', function () {
      if (!isSwiping) return;
      isSwiping = false;
      paused = false;
      start();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else if (!paused) start();
    });

    // React to a user toggling their reduced-motion preference at runtime.
    if (reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', function () {
        if (reduceMotion.matches) stop();
        else start();
      });
    }

    goto(0);
    start();
  });
})();

/* ==========================================================================
   Login page: toggle between the sign-in and password-recovery panels
   inside the card. Opens the recover panel when:
     - the URL fragment is #recover, OR
     - the recover form was just posted (server rendered success or errors).
   Clicking Forgot password? / Back to sign in flips between the two.
   ========================================================================== */
(function () {
  'use strict';

  var card = document.querySelector('[data-login-card]');
  if (!card) return;

  var loginPanel = card.querySelector('[data-login-panel="login"]');
  var recoverPanel = card.querySelector('[data-login-panel="recover"]');
  if (!loginPanel || !recoverPanel) return;

  function show(panel) {
    var openRecover = panel === 'recover';
    recoverPanel.hidden = !openRecover;
    loginPanel.hidden = openRecover;
    // Move focus into the newly-shown panel's first field for keyboard users.
    var first = (openRecover ? recoverPanel : loginPanel).querySelector('input, button, a');
    if (first) first.focus({ preventScroll: true });
  }

  card.querySelectorAll('[data-recover-open]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      show('recover');
      history.replaceState(null, '', '#recover');
    });
  });
  card.querySelectorAll('[data-recover-close]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      show('login');
      history.replaceState(null, '', window.location.pathname);
    });
  });

  // Initial view: prefer server-rendered post state, then URL hash.
  var postedSuccess = recoverPanel.querySelector('[data-recover-success]');
  var postedErrored = recoverPanel.querySelector('[data-recover-errored]');
  if (postedSuccess || postedErrored || window.location.hash === '#recover') {
    show('recover');
  }
})();

/* ==========================================================================
   Preserve ?checkout_url= across customer form posts. When Shopify redirects
   an unauthenticated shopper from checkout to /account/login, it appends
   ?checkout_url=/checkouts/... . The customer_login / guest_login / create_
   customer forms POST to /account/login and lose the query string, so
   Shopify has no target to redirect to and drops the shopper back on the
   account home page. Inject the checkout URL as a hidden field so the round
   trip completes and the shopper lands back in checkout.
   ========================================================================== */
(function () {
  'use strict';

  var params = new URLSearchParams(window.location.search);
  var checkoutUrl = params.get('checkout_url');
  if (!checkoutUrl) return;

  // Cover any customer form on the page: login, guest login, register.
  var actions = ['/account/login', '/account/guest_login', '/account/register'];
  document.querySelectorAll('form[action]').forEach(function (form) {
    var action = form.getAttribute('action').split('?')[0];
    if (actions.indexOf(action) === -1) return;
    if (form.querySelector('input[name="checkout_url"]')) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'checkout_url';
    input.value = checkoutUrl;
    form.appendChild(input);
  });

  // {% form 'guest_login' %} posts to /account/login (not a dedicated
  // /account/guest_login endpoint) — Shopify branches on the payload — so
  // the action attribute can't be used to identify it. main-login.liquid
  // tags the guest form with the .js-guest-login class for this hook.
  //
  // Shopify rejects the guest submission when the store requires accounts
  // and bounces back to /account/login — the shopper sees no progress.
  // When we already have a checkout URL in hand, skip that round trip and
  // send them straight to checkout, which handles the guest-or-not decision
  // on its own with a clear message either way.
  document.querySelectorAll('form.js-guest-login').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      window.location.assign(checkoutUrl);
    });
  });
})();

/* ==========================================================================
   Customer addresses page: edit / add toggles, delete confirmation, and a
   country → province cascade driven by data-provinces on each country option
   (which Shopify's all_country_option_tags renders for us). Everything is
   delegated on document so it works for any addresses rendered per page.
   ========================================================================== */
(function () {
  'use strict';

  function toggleEdit(id, open) {
    var view = document.getElementById('view_address_' + id);
    var edit = document.getElementById('edit_address_' + id);
    if (view) view.hidden = open;
    if (edit) edit.hidden = !open;
  }

  document.addEventListener('click', function (e) {
    var editBtn = e.target.closest('[data-address-edit]');
    if (editBtn) { toggleEdit(editBtn.getAttribute('data-address-edit'), true); return; }

    var cancelBtn = e.target.closest('[data-address-edit-cancel]');
    if (cancelBtn) { toggleEdit(cancelBtn.getAttribute('data-address-edit-cancel'), false); return; }

    var addOpen = e.target.closest('[data-address-add-open]');
    if (addOpen) {
      var addForm = document.getElementById('add_address');
      if (addForm) { addForm.hidden = false; addOpen.hidden = true; }
      return;
    }
    var addCancel = e.target.closest('[data-address-add-cancel]');
    if (addCancel) {
      var addForm2 = document.getElementById('add_address');
      var addBtn = document.getElementById('add_address_btn');
      if (addForm2) addForm2.hidden = true;
      if (addBtn) addBtn.hidden = false;
      return;
    }

    var delBtn = e.target.closest('[data-address-delete]');
    if (delBtn) {
      e.preventDefault();
      var confirmMsg = delBtn.getAttribute('data-address-confirm') || 'Delete this address?';
      if (!window.confirm(confirmMsg)) return;
      fetch(delBtn.getAttribute('data-address-delete'), {
        method: 'DELETE',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    }
  });

  /* Country → province cascade. Each country <option> carries a
     data-provinces JSON blob; on change we parse it and rebuild the paired
     province <select>. If the country has no provinces the whole row hides. */
  function syncProvinces(countrySelect) {
    var targetId = countrySelect.getAttribute('data-province-target');
    var container = targetId ? document.getElementById(targetId) : null;
    if (!container) return;
    var provinceSelect = container.querySelector('select');
    if (!provinceSelect) return;

    var opt = countrySelect.options[countrySelect.selectedIndex];
    var raw = opt ? opt.getAttribute('data-provinces') : '[]';
    var provinces = [];
    try { provinces = JSON.parse(raw || '[]'); } catch (e) { provinces = []; }

    if (!provinces.length) {
      container.hidden = true;
      provinceSelect.innerHTML = '';
      return;
    }

    var wanted = provinceSelect.getAttribute('data-default') || '';
    provinceSelect.innerHTML = '';
    provinces.forEach(function (pair) {
      var o = document.createElement('option');
      o.value = pair[0];
      o.textContent = pair[1];
      if (pair[0] === wanted) o.selected = true;
      provinceSelect.appendChild(o);
    });
    container.hidden = false;
  }

  document.querySelectorAll('[data-country-select]').forEach(function (sel) {
    var def = sel.getAttribute('data-default');
    if (def) {
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value === def) { sel.selectedIndex = i; break; }
      }
    }
    syncProvinces(sel);
    sel.addEventListener('change', function () { syncProvinces(sel); });
  });
})();

/* ==========================================================================
   USP strip: swipeable, auto-advancing on mobile (< 768px). Desktop keeps
   the static 3-column grid, so the controller no-ops there and re-engages
   on resize into mobile. Pauses while the user is touching the track and
   when the tab isn't visible; syncs the current index if the user swipes
   past the auto-advance position.
   ========================================================================== */
(function () {
  'use strict';

  var list = document.querySelector('.usp__list');
  if (!list) return;
  var items = list.querySelectorAll('.usp__item');
  if (items.length <= 1) return;

  var INTERVAL = 4000;
  var mq = window.matchMedia('(max-width: 767px)');
  var index = 0;
  var timer = null;
  var paused = false;

  function next() {
    index = (index + 1) % items.length;
    list.scrollTo({ left: items[index].offsetLeft, behavior: 'smooth' });
  }

  function start() {
    stop();
    if (!mq.matches || paused || document.hidden) return;
    timer = setInterval(next, INTERVAL);
  }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }

  list.addEventListener('touchstart', function () { paused = true; stop(); }, { passive: true });
  list.addEventListener('touchend', function () { paused = false; start(); }, { passive: true });

  // Resync index when the user scrolls manually so the next auto-advance
  // continues from where they landed.
  var scrollDebounce = null;
  list.addEventListener('scroll', function () {
    clearTimeout(scrollDebounce);
    scrollDebounce = setTimeout(function () {
      var closest = 0, min = Infinity;
      for (var i = 0; i < items.length; i++) {
        var d = Math.abs(items[i].offsetLeft - list.scrollLeft);
        if (d < min) { min = d; closest = i; }
      }
      index = closest;
    }, 150);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop(); else if (!paused) start();
  });
  if (mq.addEventListener) {
    mq.addEventListener('change', function () { mq.matches ? start() : stop(); });
  }

  start();
})();

/* ==========================================================================
   Product description accordions.

   The M12 Plus description ships an inline IIFE that wires accordions via
   [data-acc], [data-acc-item], [data-acc-trigger] and [data-acc-panel]
   attributes. Newer products (Zoe Compact Tall, etc.) reuse the same class
   structure — .acc / .acc__item / .acc__trigger / .acc__panel — but the
   merchant authored them without the data-* markers, so the M12's script
   silently no-ops on those pages. This block wires up any .product__description
   accordion by class alone, which the theme controls, so every product with
   the pattern works whether or not the copy-writer remembered the attributes.

   Idempotency: we set / respect data-acc-ready on each group, so a page where
   the merchant's inline IIFE already wired things up (M12) leaves us with
   nothing to do. Same guard on shopify:section:load in the editor.
   ========================================================================== */
(function () {
  'use strict';

  var GROUP_SEL = '.product__description .acc';
  var ITEM_SEL = '.acc__item';
  var TRIGGER_SEL = '.acc__trigger';
  var PANEL_SEL = '.acc__panel';
  var uid = 0;

  /* Nested groups' items also show up in the outer group's querySelectorAll,
     so decide ownership by walking back to the nearest ancestor group. */
  function ownedBy(scope, selector, boundary) {
    return Array.prototype.filter.call(
      scope.querySelectorAll(selector),
      function (el) { return el.closest(boundary) === scope; }
    );
  }

  function firstOwnedInItem(item, selector) {
    var matches = item.querySelectorAll(selector);
    for (var i = 0; i < matches.length; i++) {
      if (matches[i].closest(ITEM_SEL) === item) return matches[i];
    }
    return null;
  }

  function setOpen(item, open) {
    var trigger = firstOwnedInItem(item, TRIGGER_SEL);
    if (!trigger) return;
    item.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    /* Closing an item collapses whatever was open inside it — otherwise a
       nested open item keeps visibility:visible on itself and stays reachable
       via keyboard while its ancestor track is clipped to zero height. */
    if (!open) {
      Array.prototype.forEach.call(
        item.querySelectorAll(ITEM_SEL + '.is-open'),
        function (nested) { setOpen(nested, false); }
      );
    }
  }

  function initGroup(group) {
    if (group.dataset.accReady === 'true') return;
    group.dataset.accReady = 'true';

    var items = ownedBy(group, ITEM_SEL, '.acc');
    var triggers = [];

    items.forEach(function (item) {
      var trigger = firstOwnedInItem(item, TRIGGER_SEL);
      var panel = firstOwnedInItem(item, PANEL_SEL);
      if (!trigger || !panel) return;

      uid++;
      if (!panel.id) panel.id = 'prod-acc-panel-' + uid;
      if (!trigger.id) trigger.id = 'prod-acc-trigger-' + uid;
      trigger.setAttribute('aria-controls', panel.id);
      if (!panel.hasAttribute('aria-labelledby')) {
        panel.setAttribute('aria-labelledby', trigger.id);
      }
      trigger.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      triggers.push(trigger);

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var willOpen = !item.classList.contains('is-open');
        setOpen(item, willOpen);
      });
    });

    /* Arrow keys move between headers in this group only; Enter/Space are
       handled for us because triggers are real <button> elements. */
    group.addEventListener('keydown', function (e) {
      var index = triggers.indexOf(e.target);
      if (index === -1) return;
      var next;
      if (e.key === 'ArrowDown') next = (index + 1) % triggers.length;
      else if (e.key === 'ArrowUp') next = (index - 1 + triggers.length) % triggers.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = triggers.length - 1;
      else return;
      e.preventDefault();
      triggers[next].focus();
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(GROUP_SEL).forEach(initGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme editor: re-run after a section is re-rendered so a merchant-edited
     description gets its accordions back. */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
